import React from "react";
import { Table } from "@tanstack/react-table";

interface PaginationControlsProps {
    table: Table<any>;
    totalItems?: number;
}

const TablePaginationControls: React.FC<PaginationControlsProps> = ({ table, totalItems }) => {
    const { pageIndex, pageSize } = table.getState().pagination;
    const pageCount = table.getPageCount();
 const currentPage = table.getState().pagination.pageIndex;
    const total =
        totalItems ??
        (Number.isFinite(pageCount) && pageCount > 0
            ? pageCount * pageSize
            : table.getPrePaginationRowModel().rows.length);
    const from = total === 0 ? 0 : pageIndex * pageSize + 1;
    const to = Math.min((pageIndex + 1) * pageSize, total);

    const canPrev = table.getCanPreviousPage();
    const canNext = table.getCanNextPage();

    return (
        <div className="po-pagination py-4  shadow-border-datatables">
            <div className="po-range">
                Showing {from} to {to} of {total} entries
            </div>

            <div className="po-actions">
                {/* Rows per page */}
                <div className="rows-group">
                    <span className="po-rows-label">Rows per page:</span>
                    <select
                        className="form-select po-page-size"
                        value={table.getState().pagination.pageSize}
                        onChange={(e) => {
                            table.setPageSize(Number(e.target.value));
                            table.setPageIndex(0);
                        }}
                    >
                        {[5, 10, 20, 50, 100].map((s) => (
                            <option key={s} value={s}>
                                {s}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Pager */}
                {/* <div className="po-nav">
          <button
            type="button"
            className="po-btn"
            onClick={() => table.previousPage()}
            disabled={!canPrev}
          >
            &lt; Previous
          </button>
          <button
            type="button"
            className="po-page active"
            onClick={() => table.setPageIndex(pageIndex)}
          >
            {pageIndex + 1}
          </button>
          <button
            type="button"
            className="po-btn"
            onClick={() => table.nextPage()}
            disabled={!canNext}
          >
            Next &gt;
          </button>
        </div> */}
                <nav className="po-nav">
                    <ul className="pagination mb-0">
                        <li className={`page-item ${!canPrev ? "disabled" : ""} me-3`}>
                            <button
                                type="button"
                                className="page-link d-flex align-items-center gap-1"
                                onClick={() => table.previousPage()}
                                disabled={!canPrev}
                                aria-label="Previous"
                            >
                                <i className="bi bi-chevron-left" />
                                <span className="d-none d-sm-inline preview-buttons">Previous</span>
                            </button>
                        </li>

                        <li className="page-item active">
                            <button
                                type="button"
                                className="page-link  pagination-button"
                                onClick={() => table.setPageIndex(pageIndex)}
                            >
                                {pageIndex + 1}
                            </button>
                        </li>

                        <li className={`page-item ${!canNext ? "disabled" : ""} ms-3`}>
                            <button
                                type="button"
                                className="page-link d-flex align-items-center gap-1"
                                onClick={() => table.nextPage()}
                                disabled={!canNext}
                                aria-label="Next"
                            >
                                <span className="d-none d-sm-inline preview-buttons">Next</span>
                                <i className="bi bi-chevron-right" />
                            </button>
                        </li>
                    </ul>
                </nav>

            </div>
        </div>
    );
};

export default TablePaginationControls;
